import React, { useEffect, useState } from "react";
import FullPageCreator from "./FullPageCreator";

function UserCreation({ userId, previousView, onClose }) {
  const [dividerId, setDividerId] = useState(null);

  useEffect(() => {
    // Check if there's a selectedDividerId in localStorage
    const storedDividerId = localStorage.getItem('selectedDividerId');
    console.log("UserCreation - Retrieved dividerId from localStorage:", storedDividerId);

    if (storedDividerId) {
      setDividerId(storedDividerId);
      console.log("UserCreation - Set dividerId state to:", storedDividerId);

      // Clear it from localStorage after retrieving it
      localStorage.removeItem('selectedDividerId');
    }

    // Check if we need to redirect to subscription page
    const redirectToSubscription = localStorage.getItem('redirectToSubscription');
    if (redirectToSubscription === 'true') {
      console.log("UserCreation - Redirecting to subscription page");
      localStorage.removeItem('redirectToSubscription');
      // Use the onClose function to navigate back, then set view to subscription
      if (onClose) {
        onClose();
        // Use a small timeout to ensure the navigation happens after the component unmounts
        setTimeout(() => {
          // We need to access the setView function from App.js
          // Since we don't have direct access, we'll use a custom event
          window.dispatchEvent(new CustomEvent('navigateToSubscription'));
        }, 100);
      }
    }
  }, [onClose]);

  return (
    <FullPageCreator
      userId={userId}
      previousView={previousView}
      onClose={onClose}
      dividerId={dividerId}
    />
  );
}

export default UserCreation;
